import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const porParaQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "Elige la opción correcta: 'Este regalo es ___ ti.'",
        options: ["por", "para", "de", "a"],
        correctAnswerIndex: 1,
        explanation: "'Para' se usa para indicar destinatario o propósito de algo."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "Completa la frase: 'Viajamos ___ avión.'",
        options: ["para", "de", "por", "con"],
        correctAnswerIndex: 2,
        explanation: "'Por' se usa para indicar medio de transporte o comunicación."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "Selecciona la opción correcta: 'Lo hago ___ ayudar a los demás.'",
        options: ["por", "para", "con", "a"],
        correctAnswerIndex: 1,
        explanation: "'Para' se usa para indicar propósito o finalidad."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "¿Cuál es la opción correcta? 'Estudié español ___ dos años.'",
        options: ["por", "para", "durante", "en"],
        correctAnswerIndex: 0,
        explanation: "'Por' se usa para indicar duración de tiempo."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "Completa la oración: 'Salimos ___ Madrid mañana temprano.'",
        options: ["por", "para", "hacia", "de"],
        correctAnswerIndex: 1,
        explanation: "'Para' se usa para indicar destino o dirección."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "Selecciona la opción correcta: 'Gracias ___ tu ayuda.'",
        options: ["por", "para", "de", "a"],
        correctAnswerIndex: 0,
        explanation: "'Por' se usa para expresar gratitud o intercambio."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "Elige la mejor opción: 'Este trabajo tiene que estar terminado ___ el viernes.'",
        options: ["por", "para", "en", "hacia"],
        correctAnswerIndex: 1,
        explanation: "'Para' se usa para indicar un plazo o fecha límite."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "Selecciona la respuesta correcta: 'Pagué 20 euros ___ esta camisa.'",
        options: ["por", "para", "de", "a"],
        correctAnswerIndex: 0,
        explanation: "'Por' se usa para indicar intercambio o precio."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "Elige la opción correcta: 'Caminamos ___ el parque todas las mañanas.'",
        options: ["por", "para", "en", "hacia"],
        correctAnswerIndex: 0,
        explanation: "'Por' se usa para indicar movimiento a través de un lugar."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "¿Cuál es la opción correcta? 'Esta carta es ___ mi abuela.'",
        options: ["por", "para", "de", "con"],
        correctAnswerIndex: 1,
        explanation: "'Para' se usa para indicar destinatario."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "Selecciona la mejor opción: 'Te cambio mi teléfono ___ tu bicicleta.'",
        options: ["para", "de", "por", "a"],
        correctAnswerIndex: 2,
        explanation: "'Por' se usa para indicar intercambio."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "Completa la frase: 'El tren pasa ___ el centro de la ciudad.'",
        options: ["para", "de", "hacia", "por"],
        correctAnswerIndex: 3,
        explanation: "'Por' se usa para indicar tránsito o movimiento a través de un lugar."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "Elige la opción correcta: 'Trabajo ___ ganar dinero.'",
        options: ["por", "para", "de", "con"],
        correctAnswerIndex: 1,
        explanation: "'Para' se usa para indicar finalidad o propósito."
    },
    {
        category: QuizCategory.POR_VS_PARA,
        questionText: "Selecciona la respuesta correcta: 'Este puente fue construido ___ los romanos.'",
        options: ["por", "para", "con", "de"],
        correctAnswerIndex: 0,
        explanation: "'Por' se usa para indicar el agente en la voz pasiva."
    }
];

export default porParaQuestions;
